<template>
  <div class="pt-5">
    <v-expansion-panel-content>
      <v-card-text style="padding: 20px;">
        <CreateCorreo
          :toSave="toSave"
          @goTosave="goTosave"
          :cuentaId="cuentaId"
          :readOnly="readOnly"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          dark
          color="#00a7e4"
          outlined
          @click="$emit('changeTab',1)"
        >
          <h4>
            Cancelar 
          </h4>
        </v-btn>
        <v-btn
          rounded
          dark
          class="common-botton"
          @click="toSave = true"
        >
          <h4 style="color: white;">
            Guardar
          </h4>
        </v-btn>
      </v-card-actions>
      <CommonActionModal
        :dialog="dialogEleccion"
        title="Creación de cuenta de correo"
        subtitle="¿Deseas crear la cuenta de correo?"
        bottonText="Si, crealo"
        @userChoice="postPutCuentaCorreo"
      />
    </v-expansion-panel-content>
  </div>
</template>

<script>
import CreateCorreo from "@/components/commonComponents/forms/CreateCorreo.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import {
  postCrearCuentaCorreo,
  editCuentaCorreoByID,
} from "@/services/cuentasCorreo/cuentasCorreo.service.js";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CreateCorreo,
    CommonActionModal,
  },
  data() {
    return {
      toSave: false,
      dialogEleccion: false,
      form: {},
      cuentaId: this.$route.params.id,
    };
  },
  methods: {
    goTosave(result, form) {
      if (result) this.dialogEleccion = true;
      this.form = form;
      this.toSave = false;
    },
    postPutCuentaCorreo(val) {
      this.dialogEleccion = false;
      if (val) {
        if (!this.cuentaId) this.postCrearCuentaCorreo();
        else this.editCuentaCorreoByID();
      }
    },
    async postCrearCuentaCorreo() {
      const finalform = {
        ...this.form,
        reglaNegocioAplicable: String(this.form.reglaNegocioAplicable),
      };

      try {
        await postCrearCuentaCorreo(finalform);
        this.$toast.success("Cuenta correo creado con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la cuenta de correo");
        this.dialogEleccion = false;
      }
    },
    async editCuentaCorreoByID() {
      const finalform = {
        ...this.form,
        reglaNegocioAplicable: String(this.form.reglaNegocioAplicable),
      };

      try {
        await editCuentaCorreoByID(finalform, this.cuentaId);
        this.$toast.success("Cuenta correo editada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la cuenta de correo");
        this.dialogEleccion = false;
      }
    },
  },
};
</script>
